import { Box, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import ConfirmComp from "src/components/shared/ConfirmComp";
import DeleteBtn from "src/components/shared/DeleteBtn";
import ProcessingBadge from "src/components/shared/ProcessingBagde";
import UpdateBtn from "src/components/shared/UpdateBtn";
import useAppGlobal from "src/context/useAppGlobal";
import useAuthGlobal from "src/context/useAuthGlobal";
import useProviderList from "src/hooks/setting/provider/useProviderList";
import useProviderRemove from "src/hooks/setting/provider/useProviderRemove";
import { v4 as uuid } from "uuid";
import ProviderCreate from "../ProviderCreate";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function useProviderBody({ searchBy, keyword, providerSelectList }) {
  const permissionCheck = useRoleCheck();
  const { userMe } = useAuthGlobal();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });
  const [whouseId, setWHouseId] = useState();
  const {
    data: providers,
    error,
    isLoading,
  } = useProviderList({
    ...pagi,
    searchField: !!searchBy ? providerSelectList[searchBy - 1]?.value : providerSelectList[0]?.value,
    searchValue: !!keyword ? keyword : undefined,
    // q: !!keyword ? keyword : undefined,
    sortField: "createdAt",
    sortOrder: "asc",
  });
  const { trigger: removeProvider } = useProviderRemove(whouseId);

  const header = [
    {
      id: uuid(),
      title: "STT",
      width: "20px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Tên NCC",
      width: "60px",
      align: "center",
    },
    {
      id: uuid(),
      title: "MST",
      width: "60px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Địa chỉ",
      width: "120px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Chi tiết liên hệ",
      width: "20px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      width: "100px",
      align: "center",
    },
  ];

  const handleSubWHUpdate = (val) => {
    handleOpenDialog({
      title: "Sửa kho con",
      content: <ProviderCreate item={val} />,
      size: "md",
    });
  };

  const handleRemoveProvider = async (item) => {
    const res = await removeProvider();
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };
  const bodyList =
    Array.isArray(providers?.data) && !!providers?.data?.length
      ? providers?.data?.map((v, i) => ({
          ...v,
          no: i + pagi?.skip + 1,
          name: (
            <Box>
              <Typography variant="body2">{v?.name ?? "-"}</Typography>
            </Box>
          ),
          // email: (
          //   <Box>
          //     <Typography>{v?.email ?? "-"}</Typography>
          //   </Box>
          // ),
          detail: (
            <Box>
              <ProcessingBadge
                value={v?.phone}
                asset={{ color: "processing", text: "processing" }}
              />
              <Typography
                variant="body2"
                mt="6px"
              >
                {v?.email}
              </Typography>
            </Box>
          ),
          includesRow: !userMe?.warehouse
            ? v?.children?.map((val, i) => ({
                col: <></>,
                name: val?.name,
                detail: (
                  <Box>
                    <ProcessingBadge
                      value={val?.managerName + " - " + val?.managerPhone}
                      asset={{ color: "processing", text: "processing" }}
                    />
                    <Typography
                      variant="body2"
                      mt="6px"
                    >
                      {val?.detailAddress + ", " + val?.ward?.name}
                    </Typography>
                  </Box>
                ),
                col1: <></>,
                action: (
                  <>
                    <UpdateBtn
                      disabled={!permissionCheck([PERMISSIONS.UPDATE_PROVIDER])}
                      handleUpdate={() => handleSubWHUpdate(val)}
                    />
                    <DeleteBtn
                      disabled={!permissionCheck([PERMISSIONS.DELETE_PROVIDER])}
                      handleDelete={() => {
                        setWHouseId(val?._id);
                        handleOpenDialog({
                          content: (
                            <ConfirmComp
                              name={val?.name}
                              onConfirm={() => handleRemoveProvider(val?._id)}
                            />
                          ),
                          size: "md",
                        });
                      }}
                    />
                  </>
                ),
              }))
            : undefined,
        }))
      : null;
  const sortData = ["no", "name", "taxCode", "fullAddress", "detail"];
  return {
    header,
    isLoading,
    error,
    setPagi,
    bodyList,
    sortData,
    total: providers?.count,
  };
}
